import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../utils/axios-base-query";
import { baseHttp } from "./http";
import * as tags from "constants/tags";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: axiosBaseQuery({ url: "" }, baseHttp),
  endpoints: (builder) => ({}),
}).enhanceEndpoints({ addTagTypes: Object.values(tags) });

export const currentVersion = 1;

export type TParams = {
  companyId?: string;
  Departments?: string[];
  pageSize?: number;
  pageNumber?: number;
  searchText?: string;
  startDate?: string;
  endDate?: string;
  orderBy?: string;
  descending?: boolean;
  year?: number;
};
